import axios from 'axios';
import authHeader from './auth-header';

//const API_URL = 'http://localhost:8080/matrix-mlm/api/mlm/state/';
const API_URL = 'https://www.edibleherbsstores.com/api/mlm/state/';

class StateService {
  getAll() {
    return axios.get(API_URL + `sorted`, { headers: authHeader() });
  }

  getAllPageable(name, page, pageSize) {
    return axios.get(API_URL + `all?name=${name}&page=${page}&size=${pageSize}`, { headers: authHeader() });
  }

  get(id) {
    return axios.get(API_URL + `one/${id}`, { headers: authHeader() });
  }

  create(state) {
    return axios.post(API_URL + `cre`, {
      code: state.code,
      name: state.name,
      countryId: state.countryId
    }, { headers: authHeader() });
  }

  update(id, state) {
    return axios.put(API_URL + `upd/${id}`, {
      code: state.code,
      name: state.name,
      countryId: state.countryId
    }, { headers: authHeader() });
  }

  delete(id) {
    return axios.delete(API_URL + `del/${id}`, { headers: authHeader() });
  }

  deleteAll() {
    return axios.delete(API_URL + `delall`, { headers: authHeader() });
  }

  getByName(name) {
    return axios.get(API_URL + `all?name=${name}`, { headers: authHeader() });
  }

  getStatesByCountry(country) {
    return axios.get(API_URL + `country?country=${country}`, { headers: authHeader() });
  }
}

export default new StateService();